import React from 'react';

/** Formata CPF (11) ou CNPJ (14) conforme a quantidade de dígitos. */
export function formatCnpjCpf(value, modo = 'auto') {
  const digits = String(value || '').replace(/\D/g, '');
  const max = modo === 'cnpj' ? 14 : modo === 'cpf' ? 11 : 14;
  const d = digits.slice(0, max);

  if (modo === 'cnpj' || (modo === 'auto' && d.length > 11)) {
    return d
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  // CPF (ou digitação inicial em modo auto)
  return d
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');
}

const inputStyle = {
  width: '100%',
  maxWidth: '100%',
  minWidth: '0',
  height: '40px',
  padding: '8px 12px',
  margin: 0,
  borderRadius: '4px',
  border: '1px solid #ccc',
  background: '#fff',
  boxSizing: 'border-box',
  display: 'block',
  fontSize: '1rem',
  fontFamily: 'inherit',
};

/**
 * @param {'auto'|'cnpj'|'cpf'} modo - auto: CPF até 11 dígitos, CNPJ acima
 */
export default function InputCnpjCpfCustom({
  value,
  onChange,
  modo = 'auto',
  disabled,
  placeholder,
  id,
  ...props
}) {
  const ph =
    placeholder ||
    (modo === 'cnpj' ? '00.000.000/0000-00' : modo === 'cpf' ? '000.000.000-00' : 'CPF ou CNPJ');

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      placeholder={ph}
      value={formatCnpjCpf(value, modo)}
      onChange={(e) => {
        const formatted = formatCnpjCpf(e.target.value, modo);
        onChange && onChange(formatted);
      }}
      disabled={disabled}
      style={inputStyle}
      {...props}
    />
  );
}
